import * as React from 'react';

import * as styles from './ParallaxBannerWrapper.css';
import { ClientComponent } from '../ClientComponent';

export const ParallaxBannerWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <section className={styles['container']} data-testid="adfox_listing_parallax_wrapper">
      <ClientComponent>{children}</ClientComponent>
      <div className={styles['spacer']} />
    </section>
  );
};
